<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="status" slot-scope="params">
        <span v-if="params.params.active == 0" style="color:red">待处理</span>
        <span v-if="params.params.active == 1">已处理</span>
      </template>
      <template #btns="params">
        <Btn v-if="params.params.active != 1 || user.user_group_id == 1" :config="btns[0]" :data="params.params" />
        <Btn v-if="params.params.active == 1 && user.user_group_id != 1" :config="viewBtn" :data="params.params" />
      </template>
    </Table>

    <FormDialog class="formDialog" ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform"
      :rules="mrules" :formCtrl="mformCtrl" :viewMode="viewMode" @onChange="onMadolFormChange"
      @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

const activeOptions = [
  { label: '待处理', value: 0 },
  { label: '已处理', value: 1 },
]

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'violation',
      getListUrl: 'getViolationDetail',
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
        {
          label: "处理状态",
          keyName: "active",
          placeholder: "请选择处理状态",
          type: "select",
          options: [
            { label: '全部', value: null },
            ...activeOptions,
          ],
        },
        {
          label: "月份选择",
          keyName: "created_at",
          placeholder: "选择日期",
          type: "month",
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号" },
        { keyName: "driver", label: "司机姓名" },
        { keyName: "created_at", label: "违章时间" },
        { keyName: "address", label: "违章地点" },
        { keyName: "content", label: "违章行为" },
        { keyName: "kpoints", label: "扣分" },
        { keyName: "fine", label: "罚款" },
        { keyName: "active", label: "处理状态", slot: "status" },
        { keyName: "active_at", label: "处理时间" },
        { keyName: "", label: "操作", fixed: 'right', slot: 'btns' },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: (params) => {
            this.viewMode = false
            this.title = "违章详情";
            this.mformCtrl.map((v) => {
              const key = v.keyName;
              this.mform[key] = params[key];
            });
            this.mform['id'] = params['id'];
            this.modalSubmitUrl = 'updateViolationDetail';
            this.showDialog();
          },
        },
      ],
      modalViewMode: false,
      viewBtn: {
        ...this.viewBtn,
        cb: (params) => {
          this.viewMode = true
          this.title = "违章详情";
          this.mformCtrl.map((v) => {
            const key = v.keyName;
            this.mform[key] = params[key];
          });
          this.showDialog();
        },
      },
      // baseParams: ['license'],
      getOptionUrl: 'getcarlist',
      viewMode: false,
      title: '违章详情',
      mform: {
        license: undefined,
        driver: undefined,
        created_at: undefined,
        address: undefined,
        content: undefined,
        kpoints: undefined,
        fine: undefined,
        active: undefined,
      },
      mrules: {
        license: [
          { required: true, message: "请选择车牌号", trigger: "blur" },
        ],
        // driver: [
        //   { required: true, message: "请选择司机姓名", trigger: "blur" },
        // ],
        created_at: [
          { required: true, message: "请选择违章时间", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请填写违章地点", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请填写违章行为", trigger: "blur" },
        ],
        kpoints: [
          { required: true, message: "请填写扣分", trigger: "blur" },
        ],
        fine: [
          { required: true, message: "请填写罚款", trigger: "blur" },
        ],
        active: [
          { required: true, message: "请选择处理状态", trigger: "blur" },
        ],
      },
      mformCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          err: "请选择车牌号",
          type: "select",
          options: [],
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请选择司机姓名",
          type: "select",
          options: [],
          disabled: true,
        },
        {
          label: "违章时间",
          keyName: "created_at",
          err: "请选择违章时间",
          type: "date",
          options: [],
        },
        {
          label: "违章地点",
          keyName: "address",
          err: "请填写违章地点",
          type: "text",
        },
        {
          label: "违章行为",
          keyName: "content",
          err: "请填写违章行为",
          type: "text",
        },
        {
          label: "扣分",
          keyName: "kpoints",
          err: "请填写扣分",
          type: "number",
        },
        {
          label: "罚款",
          keyName: "fine",
          err: "请填写罚款",
          type: "number",
        },
        {
          label: "处理状态",
          keyName: "active",
          err: "请选择处理状态",
          type: "select",
          options: activeOptions,
        },
      ],
      relation: [],
    };
  },
  methods: {
    onSearchItemChange({ key }) {
      if (['fleet', 'active', 'created_at'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    setQuery() {
      const { license } = this.$route.query
      if (license) {
        this.formInline.license = license
        // console.log(this.formInline)
        this.getList()
      }
    },
    setOptions({ data, driver_list }) {
      // 储存车与司机对应关系
      this.relation = [...data]
      this.mformCtrl.map(v => {
        if (v.keyName == 'license') {
          v.options = data.map(val => {
            return {
              label: val.license,
              value: val.license,
            }
          })
        } else if (v.keyName == 'driver') {
          v.options = driver_list.map(val => {
            return {
              label: val,
              value: val,
            }
          })
        }
      })
    },
    addItem() {
      this.title = '违章详情'
      // 给需要设置的数据赋予初始值
      this.mform = {
        license: undefined,
        driver: undefined,
        active: 0,
        created_at: undefined,
        address: undefined,
        content: undefined,
        kpoints: undefined,
        fine: undefined,
      };
      this.modalSubmitUrl = 'setViolationStatistics';
      this.showDialog();
    },
    onMadolFormChange({ key, value }) {
      if (key === 'license') {
        // console.log(key, value)
        this.relation.map(v => {
          if (v[key] === value) {
            console.log({ ...v })
            this.mform['driver'] = v['driver']
            console.log({ ...this.mform })
            this.$forceUpdate()
          }
        })
      }
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setQuery()
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(0, 1)
      this.baseParams.push('fleet')
      this.getList()
    }
  },
  mounted() {
    this.setQuery();
    this.getOptions({ userid: this.user.id });
    this.getFleet();
  },
};
</script>

<style lang="less" scoped>
.formDialog {

  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }
}
</style>
